import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-moc-responses-table',
  templateUrl: './moc-responses-table.component.html',
  styleUrls: ['./moc-responses-table.component.scss']
})
export class MocResponsesTableComponent {
  @Input() data: any[] = [];
  @Input() totalCount: number = 0;
  @Input() loading: boolean = false;
  @Input() currentPage: number = 1;
  @Input() pageSize: number = 20;
  @Input() totalPages: number = 0;
  @Input() selectedRating: number | null = null;

  @Input() filterChips: { label: string; group: string }[] = [];
  @Output() pageChange = new EventEmitter<number>();
  @Output() ratingChange = new EventEmitter<number | null>();
  @Output() clearFilters = new EventEmitter<void>();

  expandedRows: Set<number> = new Set();

  get displayData(): any[] {
    return this.data || [];
  }

  get showingFrom(): number {
    return this.displayData.length > 0 ? (this.currentPage - 1) * this.pageSize + 1 : 0;
  }

  get showingTo(): number {
    const to = this.currentPage * this.pageSize;
    return to > this.totalCount ? this.totalCount : to;
  }

  getRatingInt(rating: number): number {
    return Math.round(rating);
  }

  isAnonymous(email: string): boolean {
    return !email || email === 'Anonymous';
  }

  get allExpanded(): boolean {
    return this.displayData.length > 0 && this.expandedRows.size === this.displayData.length;
  }

  toggleRow(index: number): void {
    if (this.expandedRows.has(index)) {
      this.expandedRows.delete(index);
    } else {
      this.expandedRows.add(index);
    }
  }

  isExpanded(index: number): boolean {
    return this.expandedRows.has(index);
  }

  toggleAllRows(): void {
    if (this.allExpanded) {
      this.expandedRows.clear();
    } else {
      this.displayData.forEach((_, i) => this.expandedRows.add(i));
    }
  }

  getInitials(name: string): string {
    if (!name || name === 'Anonymous') return '';
    return name.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase();
  }

  getAvatarColor(name: string): string {
    if (!name || name === 'Anonymous') return '#bdbdbd';
    const colors = ['#1976d2', '#388e3c', '#f57c00', '#7b1fa2', '#c62828', '#00796b', '#0288d1', '#455a64'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  }

  onRatingFilterChange(rating: any) {
    this.ratingChange.emit(rating);
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }
}
